import React from 'react';
// import '../../Assets/Css/AttendanceDetails.scss';
import { useNavigate, useParams } from 'react-router-dom';
import Map from "../../Assets/Images/Attendance/map-person.svg"
import AttendancebyHour from "../../Assets/Images/Attendance/AttendancebyHour"

const events = [
  {
    id: 1,
    date: '20-09-2024',
    day: 'Friday',
    status: 'Absent',
    clockTimes: [],
    total: '-',
    location: ''
  },
  {
    id: 2,
    date: '19-09-2024',
    day: 'Thursday',
    status: 'Present',
    clockTimes: [
      { clockIn: '10:10 am', clockOut: '01:16 pm', location: 'Ahmedabad', workType: 'Office' },
      { clockIn: '01:57 pm', clockOut: '-', location: 'Ahmedabad', workType: 'Home' }
    ],
    total: '9h 38m',
    location: 'Ahmedabad (office)'
  },
  {
    id: 3,
    date: '18-09-2024',
    day: 'Wednesday',
    status: 'Present',
    clockTimes: [
      { clockIn: '10:21 am', clockOut: '02:22 pm', location: 'Ahmedabad', workType: 'Office' },
      { clockIn: '03:01 pm', clockOut: '07:00 pm', location: 'Ahmedabad', workType: 'Field' }
    ],
    total: '7h 59m',
    location: 'Ahmedabad (office)'
  },
];

const AttendanceDetails = () => {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <div className='attendance-table p-0'>
      <div className="attandance_details_header">
        <div>
          <h4> Attendance Details</h4>
        </div>
        <div className="edit-btn">
          <button
            type="submit"
            className="custom-btn"
            onClick={() => navigate(-1)}
          >
            {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
            Cancel
            {/* )} */}
          </button>
        </div>
      </div>

      <div className="attendance-page">
        <div className='row'>

          <div className='col-lg-12 col-md-12 col-sm-12'>
            <div className="header-section">
              <img
                src="https://via.placeholder.com/60"
                alt="Profile"
                className="profile-pic me-3"
              />
              <div>
                <h4 className="m-0">Raj Viradiya <img src='https://via.placeholder.com/60' alt='country' className='countryimg' /></h4>
                <p className="m-0">Developer</p>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div className="content-section">
              <div className='row'>
                <div className='col-lg-12 date'>
                  <h5>Date - 19-09-2024</h5>
                </div>

                <div className='clockinbox'>
                  <p>Clock In</p>
                  <h6>10:10 AM</h6>
                </div>

                <div className="clock-time-circle">
                  <span>9h 38m</span>
                </div>

                <div className='clockinbox'>
                  <p>Clock Out</p>
                  <h6>08:30 PM  (Did not clock out)</h6>
                </div>

              </div>
            </div>
          </div>

          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div id="content" className='activity'>
              <ul className="timeline">
                {events?.map((item1, index) => (
                  <>
                    {item1?.clockTimes?.map((item, i) => (
                      <li className="event" key={i}>
                        <div>
                          <h3>Clock In</h3>
                          <div className='clockin-comp'>
                            <h6>
                              <AttendancebyHour />
                              {item1.date}
                            </h6>
                            <h6>
                              {item.clockIn}
                            </h6>
                            <h6>
                              <img src={Map} alt='map' />
                              {`${item.location}(${item.workType})`}
                            </h6>
                            <h6>
                              {item1.status}
                            </h6>
                          </div>
                        </div>
                        <div>
                          <h3>Clock out</h3>
                          <div className='clockin-comp '>
                            <h6>
                              <AttendancebyHour />
                              {item1.date}
                            </h6>
                            <h6>
                              {item.clockOut || `Did not clock out`}
                            </h6>
                          </div>
                        </div>
                      </li>
                    ))}
                  </>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default AttendanceDetails;
